import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,CCol,
	CForm,CFormInput,CFormTextarea,CFormCheck,CFormSelect,
	CInputGroup,CInputGroupText,CButton,CFormLabel,
	CModal,CModalBody,CModalFooter,CModalHeader,
	CModalTitle,CCloseButton,
} from '@coreui/react';
import { isMobile } from "react-device-detect";
import CIcon from '@coreui/icons-react';
import { 
	MyButton,
	MyDialoglookup
} from './index';
import { Konfirm } from '../helpers/onConfirm';
import { UFunc } from "../helpers/functions";

const pjson 	= require('../../package.json')
const MyDialogformsubjective = props => {
	const { 
		showDlg, toggleShow, pasienDataObj, 
		showToast, setLoading, setSessionaktif, prosesExpired,
		...rest 
	} = props;

	const uDispatch 				= useDispatch();
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uDatainputObj 			= useSelector(state => state.gDatasubjective) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");

	const [uEfekview,setEfekview] 	= React.useState(false);
	const [uEfekview2,setEfekview2] = React.useState(false);
	const [uDataformObj,setDataformObj] 	= React.useState({});
	const [uDataanamnaseArr,setDataanamnaseArr] 	= React.useState([]);

	//--DLG_VIEW--/
	const [uISDlglookupshow,setDlglookupshow] 	= React.useState(false);
	const [uDlglookupObj,setDlglookupObj] 		= React.useState({});
	//--END DLG_VIEW--/

	const hdlKlikAnamnaselookup = () => {
		const vTmpArr	= uDataanamnaseArr.map(vItems => {
			return {id:vItems.id,caption:vItems.nama_anamnase}
		});

		setDlglookupObj({
			dlg_header: "Pilih: ANAMNASE",
			dlg_input: "",
			data_arr: vTmpArr,
		});

		setDlglookupshow(true);
	}
	const hdlKlikDlglookuppilih = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		const vArridx	= UFunc.getObjectIndeks(uDataanamnaseArr,_IDITEM);

		setDataformObj({...uDataformObj,
			anamnase_id: uDataanamnaseArr[vArridx].id,
			anamnase_caption: uDataanamnaseArr[vArridx].nama_anamnase,
		});

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout)
			const vElfocus = document.getElementById("inpkeluhantambahan");
			vElfocus && vElfocus.focus()
		},350)
	
		setDlglookupshow(false);
	}
	const hdlKlikSimpan = () => {
		//--VALIDASI--/
		let vElfocus = document.getElementById("inpanamnasecaption");
		if((parseInt(uDataformObj.anamnase_id)||"0") <= 0) {
			vElfocus && vElfocus.focus()
			showToast("Keluhan Utama / Anamnase Harus Dipilih Dengan Benar !"); return
		}
		//--ALERGI_OBAT--/
		vElfocus = document.getElementById("inpalergiobatteks");
		if(uDataformObj.alergi_obat_status === "YA")
			if((uDataformObj.alergi_obat_teks||"").trim() === "") {
				vElfocus && vElfocus.focus()
				showToast("Alergi Obat Harus Disebutkan !"); return
			}
		//--END ALERGI--/
		//--ALERGI_MAKANAN--/
		vElfocus = document.getElementById("inpalergimakanteks");
		if(uDataformObj.alergi_makanan_status === "YA")
			if((uDataformObj.alergi_makanan_teks||"").trim() === "") {
				vElfocus && vElfocus.focus()
				showToast("Alergi Makanan Harus Disebutkan !"); return
			}
		//--END ALERGI_MAKANAN--/

		const updatedObj = Object.fromEntries(
			Object.entries(uDataformObj).map(([key, value]) => [
				key,
				(value && typeof(value) === "string" && (value||"").trim() === "") ? undefined : value,
			])
		);
		//--END VALIDASI--/

		uDispatch({type: "set", gDatasubjective: updatedObj});
		uDispatch({type: "set", gISSubjectivesimpan: true});
	}

	const contentMain = () => {
		return (
		<>
		<small>
		<CForm className="px-lg-5">
		<CRow className="my-2">
			<CCol md="5" className="fw-bolder text-uppercase">Keluhan Utama</CCol>
			<CCol className="text-end">
			<CInputGroup size="sm">
				<CFormInput size="sm" readOnly={true}
					placeholder="---Pilih Anamnase SCT"
					value={uDataformObj.anamnase_caption || ""}
					onChange={(e)=>setDataformObj({...uDataformObj,anamnase_caption: e.target.value})}
					onClick={()=>hdlKlikAnamnaselookup()}
					id="inpanamnasecaption"/>
				<CButton size="sm" color="dark"
					onClick={()=>hdlKlikAnamnaselookup()}
					id="btnanamnesalookup">
					<CIcon icon="cilSearch"/>
				</CButton>
			</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol md="5">Keluhan Tambahan</CCol>
			<CCol className="text-end">
				<CFormInput size="sm"
					maxLength={100}
					value={uDataformObj.keluhan_tambahan}
					onChange={(e)=>setDataformObj({...uDataformObj,keluhan_tambahan: e.target.value})}
					id="inpkeluhantambahan"/>
			</CCol>
		</CRow>

		<div className="fw-bolder p-2 my-3 border-top border-bottom">
		RIWAYAT PENYAKIT
		</div>

		<CRow className="my-2">
			<CCol md="5">Penyakit Saat Ini</CCol>
			<CCol className="text-end">
				<CFormInput size="sm"
					maxLength={100}
					value={uDataformObj.penyakit_sekarang}
					onChange={(e)=>setDataformObj({...uDataformObj,penyakit_sekarang:e.target.value})}
					id="inppenyakitsekarang"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol md="5">Penyakit Terdahulu</CCol>
			<CCol className="text-end">
				<CFormInput size="sm"
					maxLength={100}
					value={uDataformObj.penyakit_dahulu}
					onChange={(e)=>setDataformObj({...uDataformObj,penyakit_dahulu:e.target.value})}
					id="inppenyakitdahulu"/>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol md="5">Penyakit Keluarga</CCol>
			<CCol className="text-end">
				<CFormInput size="sm"
					maxLength={100}
					value={uDataformObj.penyakit_keluarga}
					onChange={(e)=>setDataformObj({...uDataformObj,penyakit_keluarga:e.target.value})}
					id="inppenyakitkeluarga"/>
			</CCol>
		</CRow>

		<div className="fw-bolder p-2 my-3 border-top border-bottom">
		RIWAYAT ALERGI
		</div>

		<CRow className="my-2">
			<CCol md="5">Alergi Obat</CCol>
			<CCol className="text-end">
				<CInputGroup size="sm">
				<CInputGroupText className="bg-light">	
				<input type="radio"
					className="me-1 align-middle"
					name="inpalergiobat"
					value="TIDAK"
					checked={uDataformObj.alergi_obat_status === "TIDAK"}
					onChange={(e)=>setDataformObj({...uDataformObj, alergi_obat_teks:"",alergi_obat_status:e.target.value})}
					id="inpalergiobattidak"/>		
				<CFormLabel for="inpalergiobattidak" className="classcursorpointer my-0">TIDAK</CFormLabel>
				</CInputGroupText>

				<span className="mx-1"/>
				<CInputGroupText className="bg-light">	
				<input type="radio"
					className="me-1 align-middle"
					name="inpalergiobat"
					value="YA"
					checked={uDataformObj.alergi_obat_status === "YA"}
					onChange={(e)=>setDataformObj({...uDataformObj,alergi_obat_status:e.target.value})}
					id="inpalergiobatya"/>		
				<CFormLabel for="inpalergiobatya" className="classcursorpointer my-0">YA</CFormLabel>
				</CInputGroupText>

				<CFormInput size="sm"
					readOnly={uDataformObj.alergi_obat_status!=="YA"}
					maxLength={100}
					placeholder="--Isikan Jika YA.."
					value={uDataformObj.alergi_obat_teks}
					onChange={(e)=>setDataformObj({...uDataformObj,alergi_obat_teks :e.target.value})}
					id="inpalergiobatteks"/>
				</CInputGroup>
			</CCol>
		</CRow>

		<CRow className="my-2">
			<CCol md="5">Alergi Makanan</CCol>
			<CCol className="text-end">
				<CInputGroup size="sm">
				<CInputGroupText className="bg-light">	
				<input type="radio"
					className="me-1 align-middle"
					name="inpalergimakan"
					value="TIDAK"
					checked={uDataformObj.alergi_makanan_status === "TIDAK"}
					onChange={(e)=>setDataformObj({...uDataformObj, alergi_makanan_teks:"",alergi_makanan_status:e.target.value})}
					id="inpalergimakantidak"/>		
				<CFormLabel for="inpalergimakantidak" className="classcursorpointer my-0">TIDAK</CFormLabel>
				</CInputGroupText>

				<span className="mx-1"/>
				<CInputGroupText className="bg-light">	
				<input type="radio"
					className="me-1 align-middle"
					name="inpalergimakan"
					value="YA"
					checked={uDataformObj.alergi_makanan_status === "YA"}
					onChange={(e)=>setDataformObj({...uDataformObj, alergi_makanan_status:e.target.value})}
					id="inpalergimakanya"/>		
				<CFormLabel for="inpalergimakanya" className="classcursorpointer my-0">YA</CFormLabel>
				</CInputGroupText>

				<CFormInput size="sm"
					readOnly={uDataformObj.alergi_makanan_status!=="YA"}
					maxLength={100}
					placeholder="--Isikan Jika YA.."
					value={uDataformObj.alergi_makanan_teks}
					onChange={(e)=>setDataformObj({...uDataformObj,alergi_makanan_teks:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpalergimakanteks"/>
				</CInputGroup>
			</CCol>
		</CRow>
		</CForm>
		</small>
		</>
		)//->
	}

	const apiLoadawal = () => {
		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_anamnesa/ld_data";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			if(output_string.tampil) {
				//console.log("(MyDialogformsubjective - apiLoadawal) output_string.dataobject : "+output_string.dataobject);
				setDataanamnaseArr(JSON.parse(output_string.dataobject || "[]"));
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogformsubjective - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			console.log("(MyDialogformsubjective - apiLoadawal) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsestest = () => {//--TIDAK_DIPAKAI--/
		setLoading(true);

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_periksa/pr_testupload";

		//console.log("(MyDialogformsubjective - hdlKlikTestupload) vDATAS : "+vDATAS);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			if(output_string.sukses) {
				showToast("DONE !","SUKSES");
			} else if(output_string.info) {
				//console.log("(MyDialogformsubjective - hdlKlikTestupload) output_string.errors : "+output_string.errors);
				alert(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogformsubjective - hdlKlikTestupload) output_string.errors : "+output_string.errors);
				const vMsg	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(MyDialogformsubjective - hdlKlikTestupload) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR")
		});
	}

	React.useEffect(()=>{
		apiLoadawal();

		return ()=>{
			setDataanamnaseArr([]);
			setDataformObj({});setDlglookupshow(false);
		}
	},[])
	React.useEffect(()=>{
		if(!showDlg) { 
			setDataformObj({}); return;
		}

		setDataformObj({...uDatainputObj});

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			//console.log("[showDlg] LEWAT")

			//if(!isMobile)
				document.getElementById("inpanamnasecaption") &&
					document.getElementById("inpanamnasecaption").focus()
		},550)
	},[showDlg])
	React.useEffect(()=>{
		if(!uISDlglookupshow) {
			setDlglookupObj({}); return;
		}
	},[uISDlglookupshow])

	return (
		<>
		<CModal size="lg"
			alignment="center"
			visible={showDlg}
			scrollable
			{...rest}>
		<CModalHeader 
			className="bg-light text-dark py-2"
			closeButton={false}>
			<CModalTitle>
				<div className="d-none d-md-block">Form Subjective</div>
				<small className="d-md-none">Form Subjective</small>
			</CModalTitle>
			<CCloseButton onClick={toggleShow}/>
		</CModalHeader>

		<CModalBody>{contentMain()}</CModalBody>

		<CModalFooter>
			<MyButton
				onClick={()=>hdlKlikSimpan()}
				id="btnDialogSimpan">
				<CIcon icon="cilCheckAlt" 
				 	className="me-1 classverticalmiddle"
					height={20}/>
				{uBahasaObj.word_simpan||"Simpan"}
			</MyButton>

			<span className="me-1"/>

			<CButton color="light" onClick={toggleShow}>{uBahasaObj.word_batal||"Batal"}</CButton>
		</CModalFooter>
		</CModal>

		<MyDialoglookup
			show={uISDlglookupshow}
			toggle={()=>setDlglookupshow(false)}
			dialogHeader={uDlglookupObj.dlg_header}
			inputValue={uDlglookupObj.dlg_input || ""}
			dataItemArr={uDlglookupObj.data_arr || []} 
			onKlikPilihItem={hdlKlikDlglookuppilih}
			id="iddialoglookup"
			{...props}/>
		</>
	)//>
}

export default MyDialogformsubjective;
